module.exports = __webpack_public_path__ + "img/sn.cd715169.svg";